import { render, staticRenderFns } from "./WorkWhitUsComponent.vue?vue&type=template&id=0041936a"
import script from "./WorkWhitUsComponent.vue?vue&type=script&lang=js"
export * from "./WorkWhitUsComponent.vue?vue&type=script&lang=js"
import style0 from "./WorkWhitUsComponent.vue?vue&type=style&index=0&id=0041936a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports